import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import client from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ContactDialog({ trigger, kind = "redazione", title }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await client.post("/contact", { ...form, kind });
      toast.success("Richiesta inviata! Ti risponderemo al più presto.");
      setForm({ name: "", email: "", message: "" });
      setOpen(false);
    } catch {
      toast.error("Errore durante l'invio. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-display uppercase text-2xl">{title || "Contattaci"}</DialogTitle>
          <DialogDescription>Compila il modulo oppure scrivici a <a href="mailto:info@legendmagazine.it" className="text-legend-red underline">info@legendmagazine.it</a></DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="c-name">Nome e Cognome</Label>
            <Input id="c-name" data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="c-email">Email</Label>
            <Input id="c-email" type="email" data-testid="contact-email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="c-msg">Messaggio</Label>
            <Textarea id="c-msg" rows={4} data-testid="contact-message" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder={kind === "sponsor" ? "Raccontaci della tua azienda e cosa vorresti promuovere..." : "Presentati e raccontaci perché vuoi entrare in redazione..."} />
          </div>
          <DialogFooter>
            <button type="submit" disabled={loading} data-testid="contact-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-legend-red hover:bg-legend-dark text-white font-bold uppercase tracking-wide px-5 py-3 rounded-sm transition-colors disabled:opacity-60">
              {loading && <Loader2 size={16} className="animate-spin" />} Invia richiesta
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
